import { SearchableEntityType } from './globalSearch.types';

export const ALL_TAB_ID = 'all';

export const ACTIONS_TAB_ID = 'actions';

export const SHORTCUTS_TAB_ID = 'shortcuts';

export const LISTBOX_DOM_ID = 'global-search-listbox';

export const INITIAL_PAGE_SIZE = 20;
export const DRILL_DOWN_PAGE_SIZE = 20;

export const RESULT_COUNT_CAP = 100;

export const SUGGESTED_CATALOGS_LIMIT = 3;

export const ENTITY_TAB_ORDER: SearchableEntityType[] = [
  'product',
  'order',
  'catalog',
  'customer',
  'invoice',
  'accountReceivable',
];

export const ENTITY_LIST_HAS_TEXTUAL_SEARCH: Record<SearchableEntityType, boolean> = {
  customer: true,
  catalog: true,
  product: false,
  order: false,
  invoice: false,
  accountReceivable: false,
};
